
// este é o subdomínio do servidor : https://sra2.somosconexaosocial.org 
//http://localhost:3001

export const API_BASE_URL = 'https://sra2.somosconexaosocial.org';

